import { z } from 'zod';

export const SiteIncidentSchema = z.object({
  shortId: z.string(),
  title: z.string(),
  culprit: z.string().nullable(),
  trend: z.enum(['new', 'spiking']),
  eventsLast24h: z.number().int().nonnegative(),
  firstSeen: z.string(),
  lastSeen: z.string().nullable(),
  permalink: z.string().nullable(),
});
export type SiteIncident = z.infer<typeof SiteIncidentSchema>;

export const SiteIncidentsResultSchema = z.union([
  z.object({
    available: z.literal(true),
    incidents: z.array(SiteIncidentSchema),
  }),
  z.object({
    available: z.literal(false),
    reason: z.string(),
  }),
]);
export type SiteIncidentsResult = z.infer<typeof SiteIncidentsResultSchema>;
